import { ArgumentException } from '../errors/errorClasses/argumentException';
import { ReservedCardProperties } from '../utility/constant/constants';
/** Throws if a string is null, empty or whitespaces */
export function throwsIfEmptyOrWhitespace(toBeValidated, varName) {
    if (!toBeValidated || !toBeValidated.trim()) {
        throw new ArgumentException(`The ${varName} cannot be null, empty or whitespace`);
    }
}
/** Throws if any reserved property is present in a Card. */
export function throwsIfContainsReservedProperties(card) {
    const cardProperties = Object.keys(card);
    if (ReservedCardProperties.some((reservedKey) => cardProperties.find((k) => k === reservedKey))) {
        throw new ArgumentException(`${ReservedCardProperties.join(', ')} are reserved properties`);
    }
}
/**
 * Checks the provided object to ensure that the property is defined on the object and is not Emtpy or Whitespace.
 * @param toBeValidated The object to check
 * @param propertyName The name of the property to validate.
 */
export function throwIfEmptyOrWhitespacePropertyExists(toBeValidated, propertyName) {
    if (propertyName in toBeValidated) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        throwsIfEmptyOrWhitespace(toBeValidated[propertyName], propertyName);
    }
}
//# sourceMappingURL=validation.js.map